import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SearchType } from '@avano/avano-components';

import { RecentSearchTypeEnum } from '../../../services';
import { EditableItemConfiguration, MultiInput } from '../multi-input';

@Component({
  selector: 'scip-search-container',
  templateUrl: './search-container.component.html',
  styleUrls: ['./search-container.component.scss']
})
export class SearchContainerComponent {
  @Input() recentSearchType: RecentSearchTypeEnum;
  @Input() quickSearchConfiguration: MultiInput;
  @Input() headerText: string;
  @Input() autoCollapseHeight: number;
  @Input() useTwoColumns: boolean;
  @Output() readonly filterSelectionChanged = new EventEmitter<EditableItemConfiguration>();

  @Input()
  set advancedSearchConfiguration(newConfiguration: MultiInput) {
    if (newConfiguration && this.useTwoColumns) {
      this._advancedSearchConfiguration = this.replaceActionButtonAction(newConfiguration);
    } else {
      this._advancedSearchConfiguration = newConfiguration;
    }
  }

  get advancedSearchConfiguration(): MultiInput {
    return this._advancedSearchConfiguration;
  }

  searchType: typeof SearchType = SearchType;
  selectedButtonType = SearchType.QUICK;
  collapseSearch: boolean;

  private _advancedSearchConfiguration: MultiInput;
  // eslint-disable-next-line @typescript-eslint/ban-types
  private originalAdvancedAction: Function;

  toggleCollapseState(): void {
    this.collapseSearch = !this.collapseSearch;
  }

  private replaceActionButtonAction(newConfiguration: MultiInput) {
    this.originalAdvancedAction = newConfiguration.actionButtonAction;
    const wrappedSearchActionConfiguration: MultiInput = newConfiguration;

    // Let's replace the action callback for the find/search action, because we
    // want to collapse if we are in two column mode
    wrappedSearchActionConfiguration.actionButtonAction = (isEmptySearch: boolean) => {
      if (window.innerWidth >= 2000) {
        // Nothing to collapse because we have massive width available and do not use the overlay mode
      } else if (!this.autoCollapseHeight) {
        // If there is no height set, we always will collapse in two column mode
        this.toggleCollapseState();
      } else if (this.autoCollapseHeight > window.innerHeight) {
        this.toggleCollapseState();
      }

      // Let's execute the original function if there was one provided
      if (this.originalAdvancedAction && this.originalAdvancedAction instanceof Function) {
        this.originalAdvancedAction(isEmptySearch);
      }
    };
    return wrappedSearchActionConfiguration;
  }
}
